// src/Components/layout/AdminLayout.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { authService } from '../services/auth';
import { userAPI, authAPI, roleAPI } from '../services/api';
// import AdminHeader from '../admin/AdminHeader';
import AddAdminModal from '../admin/Modals/AddAdminModal';
import ChangePasswordModal from '../admin/Modals/ChangePasswordModal';
import NotificationBell from '../notifications/NotificationBell';
import AdminSubscriptionModal from '../admin/AdminSubscriptionModal'; // ADD THIS IMPORT

// Icons (using simple SVG icons)
const icons = {
  overview: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
    </svg>
  ),
  subscriptions: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
    </svg>
  ),
  users: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
    </svg>
  ),
  notifications: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
    </svg>
  ),
  analytics: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    </svg>
  ),
  logs: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
    </svg>
  ),
  verify: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
    </svg>
  ),
  logout: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
    </svg>
  ),
  settings: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  )
};

const AdminLayout = ({ children, activeTab: initialTab = 'overview' }) => {
  const [activeTab, setActiveTab] = useState(initialTab);
  const [showAddAdminModal, setShowAddAdminModal] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showAddSubscriptionModal, setShowAddSubscriptionModal] = useState(false); // ADD THIS
  const [showSidebar, setShowSidebar] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [roles, setRoles] = useState([]);
  const [loadingRoles, setLoadingRoles] = useState(false);
  const [adminForm, setAdminForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    roleId: ''
  });
  const [formErrors, setFormErrors] = useState({});
  const [actionLoading, setActionLoading] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [passwordErrors, setPasswordErrors] = useState({});
  const [unreadCount, setUnreadCount] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();
  const currentUser = authService.getCurrentUser();
  const isAdmin = authService.isAdmin();

  // Handle mobile responsiveness
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile) {
        setShowSidebar(false);
      } else {
        setShowSidebar(true);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fetch unread count
  const fetchUnreadCount = useCallback(async () => {
    try {
      const response = await authAPI.getUnreadCount();
      setUnreadCount(response.data.count || 0);
    } catch (error) {
      console.error('Error fetching unread count:', error);
    }
  }, []);

  // Fetch roles
  const fetchRoles = useCallback(async () => {
    try {
      setLoadingRoles(true);
      const response = await roleAPI.getAll();
      setRoles(response.data.data || []);
    } catch (error) {
      console.error('Error fetching roles:', error);
      toast.error('Failed to load roles');
    } finally {
      setLoadingRoles(false);
    }
  }, []);

  useEffect(() => {
    if (!isAdmin) {
      toast.error('You do not have permission to access this page');
      navigate('/');
      return;
    }
    fetchRoles();
    fetchUnreadCount();
    
    // Listen for notification-read events
    const handleNotificationRead = () => {
      fetchUnreadCount();
    };
    window.addEventListener('notification-read', handleNotificationRead);
    return () => window.removeEventListener('notification-read', handleNotificationRead);
  }, [isAdmin, navigate, fetchRoles, fetchUnreadCount]);

  // Listen for Add Subscription modal events - ADD THIS
  useEffect(() => {
    const handleOpenAddSubscription = () => {
      setShowAddSubscriptionModal(true);
    };
    
    window.addEventListener('openAddSubscriptionModal', handleOpenAddSubscription);
    return () => window.removeEventListener('openAddSubscriptionModal', handleOpenAddSubscription);
  }, []);

  // Listen for Refresh Subscriptions events - ADD THIS
  useEffect(() => {
    const handleRefreshSubscriptions = () => {
      // Dispatch a custom event that the subscriptions table can listen to
      window.dispatchEvent(new Event('refreshSubscriptionsData'));
    };
    
    window.addEventListener('refreshSubscriptions', handleRefreshSubscriptions);
    return () => window.removeEventListener('refreshSubscriptions', handleRefreshSubscriptions);
  }, []);

  // Set active tab based on current path
  useEffect(() => {
    const path = location.pathname;
    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get('tab');
    
    if (path === '/admin') {
      if (tabParam) {
        setActiveTab(tabParam);
      } else {
        setActiveTab('overview');
      }
    } else if (path === '/notifications') {
      setActiveTab('notifications');
    } else if (path === '/admin/users') {
      setActiveTab('users');
    } else if (path === '/admin/analytics') {
      setActiveTab('analytics');
    } else if (path === '/admin/logs') {
      setActiveTab('logs');
    } else if (path === '/admin/verify') {
      setActiveTab('verify');
    }
  }, [location]);

  const handleLogout = () => {
    authService.logout();
    toast.success('Logged out successfully');
    navigate('/');
  };

  const validateForm = () => {
    const errors = {};
    if (!adminForm.firstName.trim()) {
      errors.firstName = 'First name is required';
    }
    if (!adminForm.lastName.trim()) {
      errors.lastName = 'Last name is required';
    }
    if (!adminForm.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(adminForm.email)) {
      errors.email = 'Email is invalid';
    }
    if (!adminForm.roleId) {
      errors.roleId = 'Please select a role';
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleAdminSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    try {
      setActionLoading(true);
      const adminData = {
        firstName: adminForm.firstName,
        lastName: adminForm.lastName,
        email: adminForm.email,
        roleId: adminForm.roleId
      };
      await userAPI.invite(adminData);
      toast.success('User invited successfully! A welcome email with credentials has been sent.');
      setShowAddAdminModal(false);
      resetAdminForm();
      fetchRoles();
      // NOTE: if this invite flow is ever wired to a visible trigger, also dispatch
      // window event 'refreshUsers' and have the users list listen for it — otherwise
      // the new user won't appear until a manual refresh (same stale-list class of bug
      // as refreshSubscriptionsData fixed for subscriptions).
      window.dispatchEvent(new Event('refreshUsers'));
    } catch (error) {
      console.error('Error inviting user:', error);
      const errorMessage = error.response?.data?.message || 'Failed to invite user';
      toast.error(errorMessage);
    } finally {
      setActionLoading(false);
    }
  };

  const resetAdminForm = () => {
    setAdminForm({
      firstName: '',
      lastName: '',
      email: '',
      roleId: ''
    });
    setFormErrors({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAdminForm(prev => ({
      ...prev,
      [name]: value
    }));
    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordForm(prev => ({
      ...prev,
      [name]: value
    }));
    if (passwordErrors[name]) {
      setPasswordErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validatePasswordForm = () => {
    const errors = {};
    if (!passwordForm.currentPassword) {
      errors.currentPassword = 'Current password is required';
    }
    if (!passwordForm.newPassword) {
      errors.newPassword = 'New password is required';
    } else if (passwordForm.newPassword.length < 6) {
      errors.newPassword = 'Password must be at least 6 characters';
    }
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      errors.confirmPassword = 'Passwords do not match';
    }
    setPasswordErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (!validatePasswordForm()) {
      return;
    }
    try {
      setActionLoading(true);
      await authAPI.changePassword({
        currentPassword: passwordForm.currentPassword,
        newPassword: passwordForm.newPassword,
        confirmPassword: passwordForm.confirmPassword
      });
      toast.success('Password changed successfully!');
      setShowChangePasswordModal(false);
      resetPasswordForm();
    } catch (error) {
      console.error('Error changing password:', error);
      const errorMessage = error.response?.data?.message || 'Failed to change password';
      toast.error(errorMessage);
    } finally {
      setActionLoading(false);
    }
  };

  const resetPasswordForm = () => {
    setPasswordForm({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    });
    setPasswordErrors({});
  };

  // Navigation tabs
  const tabs = [
    { id: 'overview', label: 'Overview', icon: icons.overview, path: '/admin' },
    { id: 'subscriptions', label: 'Subscriptions', icon: icons.subscriptions, path: '/admin?tab=subscriptions' },
    { id: 'users', label: 'Users', icon: icons.users, path: '/admin?tab=users' },
    { id: 'notifications', label: 'Notifications', icon: icons.notifications, path: '/notifications' },
    { id: 'analytics', label: 'Analytics', icon: icons.analytics, path: '/admin?tab=analytics' },
    { id: 'logs', label: 'Activity Logs', icon: icons.logs, path: '/admin?tab=logs' },
    { id: 'verify', label: 'Manual Verify', icon: icons.verify, path: '/admin?tab=verify' }
  ];

  const handleTabClick = (tab) => {
    setActiveTab(tab.id);
    navigate(tab.path);
    if (isMobile) {
      setShowSidebar(false);
    }
  };

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  return (
    <div className="min-h-screen bg-gray-100 flex">
      {/* Mobile menu button */}
      <div className="md:hidden fixed top-4 left-4 z-50">
        <button
          onClick={toggleSidebar}
          className="p-2 bg-white rounded-lg shadow-md hover:bg-gray-50"
        >
          <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      {/* Sidebar */}
      <div
        className={`fixed md:relative z-40 h-full bg-white shadow-lg transition-all duration-300 ease-in-out flex flex-col ${
          showSidebar ? 'translate-x-0' : '-translate-x-full'
        } md:translate-x-0`}
        style={{ width: '260px' }}
      >
        {/* Sidebar Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">A</span>
            </div>
            <span className="text-lg font-semibold text-gray-800">Admin Panel</span>
          </div>
          <button
            onClick={toggleSidebar}
            className="md:hidden p-1 hover:bg-gray-100 rounded"
          >
            <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* User Info */}
        <div className="p-4 border-b border-gray-200">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center">
              <span className="text-gray-600 font-semibold">
                {currentUser?.fullName?.charAt(0) || 'A'}
              </span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-800 truncate">
                {currentUser?.fullName || 'Admin'}
              </p>
              <p className="text-xs text-gray-500 truncate">
                {currentUser?.email || 'admin@example.com'}
              </p>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto p-2">
          {tabs.map((tab) => {
            const isNotifications = tab.id === 'notifications';
            return (
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab)}
                className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                  activeTab === tab.id
                    ? 'bg-blue-50 text-blue-600'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-800'
                }`}
              >
                <span className={`${activeTab === tab.id ? 'text-blue-600' : 'text-gray-400'}`}>
                  {tab.icon}
                </span>
                <span className="text-sm font-medium flex-1 text-left">{tab.label}</span>
                {isNotifications && unreadCount > 0 && (
                  <span className="bg-red-500 text-white text-xs px-2 py-0.5 rounded-full">
                    {unreadCount > 99 ? '99+' : unreadCount}
                  </span>
                )}
              </button>
            );
          })}
        </nav>

        {/* Sidebar Footer */}
        <div className="border-t border-gray-200 p-2">
          <button
            onClick={() => setShowChangePasswordModal(true)}
            className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-600 hover:bg-gray-50 hover:text-gray-800 transition-colors"
          >
            <span className="text-gray-400">{icons.settings}</span>
            <span className="text-sm font-medium">Change Password</span>
          </button>
          
          <button
            onClick={handleLogout}
            className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-red-600 hover:bg-red-50 transition-colors mt-1"
          >
            <span className="text-red-400">{icons.logout}</span>
            <span className="text-sm font-medium">Logout</span>
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-h-screen">
        {/* Overlay for mobile */}
        {showSidebar && isMobile && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
            onClick={toggleSidebar}
          />
        )}

        {/* Top Bar with Notification Bell */}
        <div className="bg-white shadow-sm px-6 py-3 flex justify-end items-center md:hidden">
          <NotificationBell />
        </div>

        {/* Content */}
        <div className="flex-1 p-4 md:p-6">
          {children}
        </div>
      </div>

      {/* Modals */}
      {showAddAdminModal && (
        <AddAdminModal
          adminForm={adminForm}
          formErrors={formErrors}
          actionLoading={actionLoading}
          onInputChange={handleInputChange}
          onSubmit={handleAdminSubmit}
          onClose={() => {
            setShowAddAdminModal(false);
            resetAdminForm();
          }}
          roles={roles}
          loadingRoles={loadingRoles}
        />
      )}

      {showChangePasswordModal && (
        <ChangePasswordModal
          passwordForm={passwordForm}
          passwordErrors={passwordErrors}
          actionLoading={actionLoading}
          onInputChange={handlePasswordChange}
          onSubmit={handleChangePassword}
          onClose={() => {
            setShowChangePasswordModal(false);
            resetPasswordForm();
          }}
        />
      )}

      {/* ADD THIS - Admin Subscription Modal */}
      {showAddSubscriptionModal && (
        <AdminSubscriptionModal
          onClose={() => {
            setShowAddSubscriptionModal(false);
            window.dispatchEvent(new Event('refreshSubscriptions'));
          }}
          onSuccess={() => {
            setShowAddSubscriptionModal(false);
            window.dispatchEvent(new Event('refreshSubscriptions'));
          }}
        />
      )}
    </div>
  );
};

export default AdminLayout;